import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '@mantine/core';

//Helpers

/** Formats a YYYY-MM-DD string to DD-MM-YYYY for display purposes. */
const formatDateDisplay = dateString => {
	if (!dateString) return '-';
	const [year, month, day] = dateString.split('-');
	const date = new Date(Number(year), Number(month) - 1, Number(day));
	if (isNaN(date.getTime())) return '-';
	return [
		String(date.getDate()).padStart(2, '0'),
		String(date.getMonth() + 1).padStart(2, '0'),
		date.getFullYear(),
	].join('-');
};

const getRiesgoBadgeColor = label => {
	const l = (label || '').toLowerCase();
	if (l.includes('alto')) return 'red';
	if (l.includes('medio')) return 'yellow';
	if (l.includes('bajo')) return 'green';
	return 'gray';
};

//Empty / loading state

const EmptyState = ({ isLoadingList }) => (
	<div className='text-center text-muted py-4'>
		{isLoadingList ? (
			<p className='mt-2'>Cargando incumplimientos...</p>
		) : (
			<>
				<i className='ri-file-warning-line' style={{ fontSize: '48px' }}></i>
				<p className='mt-2'>No hay incumplimientos registrados</p>
			</>
		)}
	</div>
);

//Table

const IncumplimientosTable = ({ incumplimientos, isLoadingList, onEdit, onDelete }) => {
	if (incumplimientos.length === 0) {
		return <EmptyState isLoadingList={isLoadingList} />;
	}

	return (
		<div className='table-responsive'>
			<table className='table table-hover table-striped align-middle table-nowrap mb-0'>
				<thead className='table-light'>
					<tr>
						<th style={{ width: '100px' }}>Acciones</th>
						<th>Incumplimiento</th>
						<th>Categoría</th>
						<th>Origen</th>
						<th>Riesgo</th>
						<th>Fecha Límite</th>
					</tr>
				</thead>
				<tbody>
					{incumplimientos.map(inc => (
						<tr key={inc._id}>
							<td>
								<ul className='list-inline mb-0'>
									<li className='list-inline-item'>
										<Link
											title='Editar'
											to='#'
											onClick={() => onEdit(inc)}
										>
											<i className='ri-pencil-line align-bottom me-2 text-primary'></i>
										</Link>
									</li>
									<li className='list-inline-item'>
										<Link
											title='Eliminar'
											to='#'
											className='remove-item-btn'
											onClick={() => onDelete(inc)}
										>
											<i className='ri-delete-bin-line align-bottom me-2 text-danger'></i>
										</Link>
									</li>
								</ul>
							</td>
							<td>
								<div
									style={{
										maxWidth: '300px',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
									}}
									title={inc.description}
								>
									{inc.description}
								</div>
							</td>
							<td>{inc._category_name || '-'}</td>
							<td>{inc._origin_name || '-'}</td>
							<td>
								<Badge
									color={getRiesgoBadgeColor(inc._risk_name)}
									variant='light'
									tt='capitalize'
								>
									{inc._risk_name || '-'}
								</Badge>
							</td>
							<td>
								{inc.no_deadline
									? 'Sin fecha límite'
									: inc.breach_date
									? formatDateDisplay(inc.breach_date)
									: '-'}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default IncumplimientosTable;
